<template>
  <div>
    <AppHeader title="Custom Close Cash" />

    <div class="container close-cash-container">
      <div class="card close-cash-card">
        <div class="row g-3 align-items-end">

          <!-- Cashier -->
          <div class="col-12 col-md-4">
            <!-- <label class="form-label">Cashier</label> -->
            <select
              id="paid_by"
              v-model="paid_by"
              name="paid_by"
              class="form-control custom-input"
            >
              <option value="0">Select a cashier</option>
            </select>
          </div>

          <!-- Date -->
          <div class="col-12 col-md-4">
            <!-- <label class="form-label">Date</label> -->
            <div class="datepicker-wrapper">
              <datepicker
                v-model="state.date"
                format="yyyy-MM-dd"
                input-class="form-control custom-input"
                @selected="parentfunctionSelectedhandler"
                @opened="datepickerOpenedFunction"
                @closed="parentfunctionCloseHandler"
              />
            </div>
          </div>

          <!-- Button -->
          <div class="col-12 col-md-4 d-grid">
            <button
              class="btn close-btn"
              @click="SyncClose()"
            >
              Close Cash
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import commonServices from "@/shared/commonServices";
import MainMenu from "@/components/MainMenu";
import AppHeader from "@/components/AppHeader";
//import DatePick from 'vue-date-pick';
import Datepicker from "vuejs3-datepicker";
import "vue-date-pick/dist/vueDatePick.css";
export default {
  mixins: [commonServices],
  mounted() {
    const nowDate = new Date();
    let year = nowDate.getFullYear();
    let month = nowDate.getMonth();
    let day = nowDate.getDate();
    this.state.date = new Date(year + "", month + "", day + "");
    this.orderDate = this.state.date;
    console.log("this.state.date", this.state.date);
    this.getUsers();

    if (localStorage.userId === undefined) {
      this.$router.push({ name: "login" });
    }
    this.language = "ar";
    if (localStorage.reports_ok === "1") {
      this.reports_ok = true;
    }
    this.logoImage =
      '<img src="' + this.logoUrl + '" width="70" height="50" alt="Logo">';
  },
  components: { MainMenu, Datepicker, AppHeader },
  data: function () {
    return {
      state: { date: new Date() },
      users: [],
      usersJson: {},
      reports_ok: false,
      select_all: false,
      dailySales: [],
      showError: false,
      mobilePaymentProviderJson: {},
      logoImage: "",
      total_sales: [],
      payment_totals: [],
      customer_payments: [],
      userSalesPaymentJson: {},
      mainErrorMsg: "",
      logoUrl: "",
      user_name: "",
      payment_total_amount: "",
      customer_payments_amount: "",
      totalSalesAmount: "",
      jsonData: {},
      language: "en",
      languageName: "",
      toggle: false,
      orderDate: "",
      paid_by: 0,
    };
  },
  methods: {
    parentfunctionSelectedhandler() {
      this.total_sales = [];
      this.payment_totals = [];
      this.customer_payments = [];
    },
    datepickerOpenedFunction() {},
    parentfunctionCloseHandler() {},
    addOption(selectbox, value, text) {
      var optn = document.createElement("OPTION");
      optn.text = text;
      optn.value = value;
      selectbox.options.add(optn);
    },

    SyncClose: async function () {
      // this.showInfo("Closing Cash For Selected Cashier");
      let dataJson = JSON.stringify({
        appId: localStorage.appId,
        orderDate: this.dateToYMD(this.state.date),
        userId: this.paid_by,
      });
      try {
        let dataURL = this.apiURL + "GiftCard/closeDailyShift1";
        let response = await axios.post(dataURL, dataJson);
        if (response.data.status === "success") {
          this.paid_by = "";
          this.state.date = new Date();
          this.showSuccess("Closed Successfully");
        }
        else {
            this.showAlert(response.data.status);
          } 
      } catch (error) {
        console.log(error);
        this.showAlert("Failed To Close Cash...");
      }
    },
    getUsers: async function () {
      this.usersJson.appId = localStorage.appId;
      let usersJson_ = JSON.stringify(this.usersJson);
      try {
        let dataURL = this.apiURL + "GiftCard/getPosUsers";
        let response = await axios.post(dataURL, usersJson_);
        if (response.data.status === "success") {
          //this.users = this.json2array(response.data.results);

          this.users = response.data.results;
          console.log("this.users", this.users);
          var dropdown = document.getElementById("paid_by");
          if (dropdown) {
            for (var i = 0; i < this.users.length; ++i) {
              this.addOption(dropdown, this.users[i].id, this.users[i].partOne);
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 20px;
}

.glyphicon.glyphicon-ok {
  font-size: 30px;
}

.button {
  font: bold 15px Arial;
  text-decoration: none;
  background-color: #eeeeee;
  color: #333333;
  /* padding: 2px 6px 2px 6px;
  border-top: 1px solid #cccccc;
  border-right: 1px solid #333333;
  border-bottom: 1px solid #333333;
  border-left: 1px solid #cccccc; */
}
.grid-container-element {
  display: grid;
  grid-template-columns: 5fr 1.5fr 1.5fr 1.5fr 0.5fr;
  grid-gap: 10px;
  border: 1px solid whitesmoke;
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  width: 100%;
}
.grid-child-element_ {
  margin: 10px;
  border: 1px solid red;
}
.grid-child-element {
  margin: 2px;
  border-left: 0px;
  border-right: 0px;
  border-top: 0px;
  padding: 0 px;
}

.close-cash-container {
  margin-top: 40px;
}

/* Card */
.close-cash-card {
  background: linear-gradient(145deg, #1f2633, #1a1f2e);
  padding: 30px;
  border-radius: 18px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.3);
}

/* Label */
.form-label {
  color: #ffffff;
  font-size: 0.95rem;
  margin-bottom: 6px;
  display: block;
}

/* Inputs */
.custom-input {
  height: 45px;
  border-radius: 10px;
  border: 1px solid rgba(255,255,255,0.08);
  background: rgba(255,255,255,0.06);
  color: #ffffff;
  padding: 8px 12px;
}

.custom-input:focus {
  border-color: var(--theme-primary);
  box-shadow: 0 0 0 2px var(--theme-bg-end);
  outline: none;
}

/* Fix Datepicker width */
.datepicker-wrapper {
  width: 100%;
}

.datepicker-wrapper input {
  width: 100% !important;
}

/* Button */
.close-btn {
  height: 45px;
  border-radius: 10px;
  background: var(--theme-primary);
  border: none;
  color: white;
  font-weight: 500;
  transition: 0.3s ease;
}

.close-btn:hover {
  transform: translateY(-2px);
}

#paid_by {
  background-color: var(--form-color);  
  color: var(--theme-text-main);   
}

#paid_by option {
  background-color: var(--theme-text-main);   
  color: #000000;      
}
/* Responsive */
@media (max-width: 768px) {
  .close-cash-card {
    padding: 20px;
  }

  .close-btn {
    margin-top: 10px;
  }

}</style>
